<template>
  <div>
    <AssisstantBar />
    <v-container fluid>
      <base-material-card
        icon="mdi-clipboard-text"
        title="ข้อมูล ผู้ทรงคุณวุฒิอื่นจากภายนอกสถานศึกษา"
        class="px-5 py-3"
      >
        <!-- ส่วนเสนอรายชื่อและอัปโหลดไฟล์ยืนยัน -->
        <v-card
          class="mb-4 pa-4"
          outlined
          v-if="periodTeachersAssisstant.period_college_enable === '1' || periodTeachersAssisstant.period_college_enable === 1"
        >
          <v-card-title class="pa-0 mb-3">
            <v-icon left color="primary">mdi-file-document-outline</v-icon>
            <span class=""
              >เสนอรายชื่อศึกษานิเทศก์หรือผู้ทรงคุณวุฒิ จำนวน
              {{ rankCount }} ราย</span
            >
          </v-card-title>

          <!-- แสดงไฟล์ที่อัปโหลดแล้ว -->
          <v-alert
            v-if="proposalFileInfo.filename"
            :type="
              proposalFileInfo.assistantcommitteeQualifiedCancelStatus ===
              'cancel_proposal_file'
                ? 'warning'
                : 'success'
            "
            prominent
            text
            class="mb-3"
          >
            <!-- กรณีปกติ (ไม่ได้ขอยกเลิก) -->
            <template
              v-if="
                proposalFileInfo.assistantcommitteeQualifiedCancelStatus !==
                  'cancel_proposal_file'
              "
            >
              <!-- Header Row -->
              <div
                class="d-flex align-center justify-space-between flex-wrap mb-2"
              >
                <div class="d-flex align-center">
                  <v-icon color="success" class="mr-2">mdi-file-check</v-icon>
                  <span class="font-weight-medium">{{
                    proposalFileInfo.filename
                  }}</span>
                </div>

                <v-chip
                  v-if="
                    proposalFileInfo.assistantcommitteeQualifiedCancelStatus ===
                      'approve_proposal'
                  "
                  color="success"
                  small
                  class="ma-1"
                >
                  <v-icon small left>mdi-check-circle</v-icon>
                  ผ่านการตรวจสอบ
                </v-chip>
              </div>

              <v-divider class="my-2"></v-divider>

              <!-- Info Row -->
              <div
                class="d-flex align-center text-caption grey--text text--darken-1 mb-3"
              >
                <v-icon x-small class="mr-1">mdi-calendar-clock</v-icon>
                <span
                  >อัปโหลดเมื่อ: {{ proposalFileInfo.upload_date || "-" }}</span
                >
              </div>

              <!-- Actions Row -->
              <div class="d-flex align-center flex-wrap" style="gap: 8px;">
                <v-btn small outlined color="info" @click="viewProposalFile()">
                  <v-icon small left>mdi-eye</v-icon>
                  ดูไฟล์
                </v-btn>

                <v-btn
                  small
                  outlined
                  color="warning"
                  @click="cancelProposal_dialog()"
                >
                  <v-icon small left>mdi-close-circle</v-icon>
                  ขอยกเลิกรายการ
                </v-btn>
              </div>

              <!-- Hint -->
              <div class="text-caption grey--text mt-3">
                <v-icon x-small class="mr-1">mdi-information</v-icon>
                ต้องการเปลี่ยนไฟล์? เลือกไฟล์ใหม่แล้วกดอัปโหลด
              </div>
            </template>

            <!-- กรณีขอยกเลิก (รอดำเนินการ) -->
            <template v-else>
              <div class="d-flex align-center mb-2">
                <v-icon color="warning" class="mr-2">mdi-clock-alert</v-icon>
                <span class="font-weight-medium"
                  >คำขอยกเลิกอยู่ระหว่างดำเนินการ</span
                >
              </div>

              <v-divider class="my-2"></v-divider>

              <div class="d-flex align-start">
                <v-icon small color="grey" class="mr-2 mt-1"
                  >mdi-message-text</v-icon
                >
                <div>
                  <div class="text-caption grey--text">เหตุผลที่ขอยกเลิก:</div>
                  <div class="body-2">
                    {{
                      proposalFileInfo.assistantcommitteeQualifiedCancelReason ||
                        "-"
                    }}
                  </div>
                </div>
              </div>
            </template>
          </v-alert>

          <v-row v-else>
            <!-- ส่วนส่งออก PDF -->
            <v-col cols="12" md="6" v-if="rankCount >= 2">
              <v-card outlined class="pa-3 fill-height">
                <div class="d-flex align-center mb-2">
                  <v-icon color="info" class="mr-2">mdi-file-pdf-box</v-icon>
                  <span class="font-weight-medium">ส่งออกแบบเสนอรายชื่อ</span>
                </div>
                <p class="text-caption grey--text mb-3">
                  ดาวน์โหลดไฟล์ PDF
                  แบบเสนอรายชื่อผู้ทรงคุณวุฒิเพื่อนำไปลงนามและประทับตรา
                </p>
                <v-btn
                  color="info"
                  @click="exportPDFProposal()"
                  :loading="exportLoading"
                  :disabled="assistantcommitteequalifieds.length === 0"
                  block
                >
                  <v-icon left>mdi-download</v-icon>
                  ส่งออกไฟล์ PDF
                </v-btn>
                <v-alert
                  v-if="assistantcommitteequalifieds.length === 0"
                  type="warning"
                  dense
                  text
                  class="mt-2 mb-0"
                >
                  กรุณาเพิ่มรายชื่อผู้ทรงคุณวุฒิก่อนส่งออกไฟล์
                </v-alert>
              </v-card>
            </v-col>

            <!-- ส่วนอัปโหลดไฟล์ยืนยัน -->
            <v-col cols="12" md="6" v-if="rankCount >= 2">
              <v-card outlined class="pa-3 fill-height">
                <div class="d-flex align-center mb-2">
                  <v-icon color="success" class="mr-2">mdi-upload</v-icon>
                  <span class="font-weight-medium"
                    >อัปโหลดไฟล์ยืนยันการเสนอรายชื่อ</span
                  >
                </div>
                <p class="text-caption grey--text mb-3">
                  แนบไฟล์ PDF ที่ลงนามและประทับตราเรียบร้อยแล้ว
                </p>

                <v-file-input
                  v-model="uploadFile"
                  label="เลือกไฟล์ PDF"
                  accept="application/pdf"
                  outlined
                  dense
                  clearable
                  prepend-icon="mdi-paperclip"
                  :rules="uploadFileRules"
                  show-size
                  @change="onFileSelected"
                />

                <v-btn
                  color="success"
                  @click="uploadProposalFile()"
                  :disabled="!uploadFile || !isValidFile"
                  :loading="uploadLoading"
                  block
                >
                  <v-icon left>mdi-cloud-upload</v-icon>
                  {{ proposalFileInfo.filename ? "อัปโหลดใหม่" : "อัปโหลด" }}
                </v-btn>
              </v-card>
            </v-col>
          </v-row>
        </v-card>

        <!-- แจ้งเตือนเมื่อไม่อยู่ในช่วงเวลาเสนอรายชื่อ -->
        <v-alert v-else type="info" prominent text class="mb-4">
          <v-row align="center">
            <v-col class="grow">
              <div class="text-h6">ไม่อยู่ในช่วงเวลาเสนอรายชื่อ</div>
              <div>กรุณาติดต่อผู้ดูแลระบบหากต้องการดำเนินการ</div>
            </v-col>
          </v-row>
        </v-alert>

        <!-- ส่วนเพิ่มรายการ -->
        <v-card class="mb-4 pa-3" outlined>
          <v-row align="center">
            <v-col cols="12" sm="6">
              <v-chip color="primary" outlined class="ma-1">
                <v-icon left small>mdi-account-group</v-icon>
                จำนวนผู้ทรงคุณวุฒิ: {{ assistantcommitteequalifieds.length }} คน
              </v-chip>
            </v-col>
            <v-col cols="12" sm="6" class="text-right">
              <v-btn
                large
                depressed
                color="primary"
                @click.native="assistantcommitteequalifiedAdd()"
                :disabled="
                  periodTeachersAssisstant.period_college_enable !== '1' &&
                  periodTeachersAssisstant.period_college_enable !== 1
                "
              >
                <v-icon left>mdi-plus-circle-outline</v-icon>
                เพิ่มรายการ
              </v-btn>
            </v-col>
          </v-row>
        </v-card>

        <!-- ตารางข้อมูล -->
        <v-data-table
          :loading="loading"
          :headers="showHeaders"
          :items="assistantcommitteequalifieds"
          :search="search"
          :items-per-page="10"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="ค้นหา"
                single-line
                hide-details
                dense
                outlined
                class="mr-4"
                style="max-width: 300px"
              />
              <v-spacer></v-spacer>
              <v-select
                v-model="selectedHeaders"
                :items="headers"
                label="เลือกคอลัมน์"
                multiple
                outlined
                dense
                return-object
                style="max-width: 300px"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index < 3" small>
                    <span>{{ item.text }}</span>
                  </v-chip>
                  <span v-if="index === 3" class="grey--text text-caption">
                    (+{{ selectedHeaders.length - 3 }} อื่นๆ)
                  </span>
                </template>
              </v-select>
            </v-toolbar>
          </template>

          <template v-slot:item.assistantcommitteeQualifiedType="{ item }">
            <v-chip
              small
              :color="
                item.assistantcommitteeQualifiedType === 'outside'
                  ? 'warning'
                  : 'success'
              "
              text-color="white"
            >
              {{
                item.assistantcommitteeQualifiedType === "outside"
                  ? "ภายนอก/เกษียณ"
                  : "ภายใน สอศ."
              }}
            </v-chip>
          </template>

          <template v-slot:item.user_status="{ item }">
            <div>
              <v-chip color="success" outlined v-if="item.user_status === 'S'">
                ศึกษานิเทศก์
              </v-chip>
            </div>
          </template>

          <template v-slot:item.assistantcommitteeQualifiedED="{ item }">
            <div v-if="item.educate_levels === '1' || item.educate_levels === 1">
              {{ item.assistantcommitteeQualifiedEDSub || "-" }}
              {{ item.assistantcommitteeQualifiedED || "-" }}
            </div>
            <div v-else-if="item.educate_levels === '2' || item.educate_levels === 2">
              {{ item.assistantcommitteeQualifiedEDMasterSub || "-" }}
              {{ item.assistantcommitteeQualifiedEDMaster || "-" }}
            </div>
            <div v-else-if="item.educate_levels === '3' || item.educate_levels === 3">
              {{ item.assistantcommitteeQualifiedEDDoctoralSub || "-" }}
              {{ item.assistantcommitteeQualifiedEDDoctoral || "-" }}
            </div>
            <div v-else><v-icon color="error">mdi-alert</v-icon> กรุณาระบุ</div>
          </template>

          <template v-slot:item.assistantcommitteequalified_budget="{ item }">
            <span v-if="item.assistantcommitteequalified_budget === 'budget'">
              จากงบประมาณ
            </span>
            <span
              v-else-if="item.assistantcommitteequalified_budget === 'income'"
            >
              จากรายได้สถานศึกษา
            </span>
          </template>

          <template v-slot:item.assistantcommitteeQualifiedFile="{ item }">
            <div v-if="item.assistantcommitteeQualifiedType === 'outside'">
              <v-btn
                v-if="String(item.assistantcommitteeQualifiedFile).length > 4"
                @click="
                  viewpdfassistantcommitteeQualifiedFile(
                    item.assistantcommitteeQualifiedFile
                  )
                "
                icon
                small
                color="info"
              >
                <v-icon>mdi-file-pdf-box</v-icon>
              </v-btn>
              <v-tooltip v-else bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" color="warning">
                    mdi-alert-circle
                  </v-icon>
                </template>
                <span>ยังไม่ได้แนบเอกสาร</span>
              </v-tooltip>
            </div>
          </template>

          <template v-slot:item.assistantcommitteeQualifiedRank="{ item }">
            <v-chip
              v-if="item.assistantcommitteeQualifiedRank !== '0'"
              small
              color="primary"
              outlined
            >
              อันดับ {{ item.assistantcommitteeQualifiedRank }}
            </v-chip>
            <span v-else class="grey--text">-</span>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  color="warning"
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="
                    assistantcommitteequalifiedEdit(
                    item.assistantcommitteeQualifiedCollege,
                      item.assistantcommitteeQualifiedIDcard
                    )
                  "
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>แก้ไข</span>
            </v-tooltip>
          </template>

          <template v-slot:item.action_s="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="item.assistantcommitteeQualifiedRank === '0'"
                  icon
                  small
                  color="error"
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="
                    assistantcommitteequalifiedDelete(
                      item.assistantcommitteeQualifiedCollege,
                      item.assistantcommitteeQualifiedIDcard
                    )
                  "
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>ลบ</span>
            </v-tooltip>
          </template>

          <template v-slot:no-data>
            <v-alert type="info" text class="ma-4">
              ยังไม่มีข้อมูลผู้ทรงคุณวุฒิ
            </v-alert>
          </template>

          <template v-slot:no-results>
            <v-alert type="warning" text class="ma-4">
              ไม่พบผลลัพธ์ "{{ search }}" ที่คุณกำลังค้นหา
            </v-alert>
          </template>
        </v-data-table>
      </base-material-card>

      <!-- Dialog เพิ่มข้อมูล -->
      <v-dialog
        v-model="addassistantcommitteequalifieddialog"
        persistent
        max-width="800"
        overlay-opacity="0.7"
        transition="dialog-bottom-transition"
      >
        <v-card class="rounded-lg" elevation="8">
          <!-- Header Section -->
          <v-card-title class="primary white--text py-4 px-6">
            <v-icon left dark size="28">mdi-account-plus</v-icon>
            <span class="font-weight-medium">
              เพิ่มข้อมูลการเสนอชื่อ ศึกษานิเทศก์ หรือผู้ทรงคุณวุฒิ
            </span>
            <v-spacer></v-spacer>
            <v-btn
              icon
              dark
              @click="addassistantcommitteequalifieddialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="pa-6">
            <v-form ref="addassistantcommitteequalifiedform" lazy-validation>
              <!-- ประเภทบุคลากร Selection -->
              <v-card outlined class="mb-6 rounded-lg overflow-hidden">
                <div class="primary lighten-5 pa-4">
                  <div
                    class="d-flex align-center justify-space-between flex-wrap"
                  >
                    <div class="d-flex align-center">
                      <v-icon color="primary" class="mr-2"
                        >mdi-account-switch</v-icon
                      >
                      <span class="font-weight-medium primary--text">
                        เลือกประเภทบุคลากร
                      </span>
                    </div>
                  </div>
                </div>

                <v-card-text class="pa-4">
                  <v-radio-group
                    v-model="assistantcommitteeQualifiedType"
                    row
                    hide-details
                    class="mt-0"
                  >
                    <v-radio value="inside" class="mr-6">
                      <template v-slot:label>
                        <v-chip
                          :color="
                            assistantcommitteeQualifiedType === 'inside'
                              ? 'success'
                              : 'grey lighten-2'
                          "
                          :text-color="
                            assistantcommitteeQualifiedType === 'inside'
                              ? 'white'
                              : 'grey darken-1'
                          "
                          label
                          class="px-4"
                        >
                          <v-icon left small>mdi-school</v-icon>
                          ศึกษานิเทศก์
                        </v-chip>
                      </template>
                    </v-radio>
                    <v-radio value="outside">
                      <template v-slot:label>
                        <v-chip
                          :color="
                            assistantcommitteeQualifiedType === 'outside'
                              ? 'primary'
                              : 'grey lighten-2'
                          "
                          :text-color="
                            assistantcommitteeQualifiedType === 'outside'
                              ? 'white'
                              : 'grey darken-1'
                          "
                          label
                          class="px-4"
                        >
                          <v-icon left small>mdi-account-tie</v-icon>
                          ผู้ทรงคุณวุฒิ
                        </v-chip>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-card-text>
              </v-card>

              <!-- ศึกษานิเทศก์ Section -->
              <v-expand-transition>
                <div v-if="assistantcommitteeQualifiedType === 'inside'">
                  <v-card outlined class="rounded-lg">
                    <v-card-title class="success lighten-5 py-3">
                      <v-icon color="success" class="mr-2">mdi-magnify</v-icon>
                      <span class="font-weight-medium success--text">
                        ค้นหาศึกษานิเทศก์
                      </span>
                    </v-card-title>

                    <v-card-text class="pa-4">
                      <v-autocomplete
                        v-model="
                          addassistantcommitteequalified.assistantcommitteeQualifiedIDcard
                        "
                        :items="personnel_temporarySuper"
                        item-text="frist_names"
                        item-value="id_card"
                        label="ค้นหาและเลือกรายการศึกษานิเทศก์"
                        prepend-inner-icon="mdi-account-search"
                        outlined
                        dense
                        clearable
                        @change="personnel_temporarySuperQuery()"
                        class="mb-0"
                      >
                        <template v-slot:item="{ item }">
                          <v-list-item-content>
                            <v-list-item-title class="font-weight-medium">
                              {{ item.frist_names }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              <v-chip
                                x-small
                                color="info"
                                text-color="white"
                                class="mr-1"
                              >
                                {{ item.position_name }}
                              </v-chip>
                              <span class="grey--text"
                                >สังกัด: {{ item.agencys }}</span
                              >
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>

                      <!-- Personnel Info Card -->
                      <v-expand-transition>
                        <v-card
                          v-if="
                            addassistantcommitteequalified.assistantcommitteeQualifiedIDcard
                          "
                          color="grey lighten-4"
                          flat
                          class="mt-4 rounded-lg"
                        >
                          <v-card-text class="pa-4">
                            <div class="d-flex align-center mb-3">
                              <v-avatar color="success" size="48" class="mr-3">
                                <v-icon dark>mdi-account</v-icon>
                              </v-avatar>
                              <div>
                                <div class="font-weight-bold">
                                  {{ personnel_temporarys.frist_names }}
                                </div>
                                <div class="caption grey--text">
                                  ข้อมูลบุคลากร
                                </div>
                              </div>
                            </div>

                            <v-divider class="mb-3"></v-divider>

                            <v-row dense>
                              <v-col cols="12" sm="6">
                                <div class="d-flex align-center mb-2">
                                  <v-icon small color="grey" class="mr-2"
                                    >mdi-briefcase</v-icon
                                  >
                                  <span class="caption grey--text mr-2"
                                    >ตำแหน่ง:</span
                                  >
                                  <span class="body-2">{{
                                    personnel_temporarys.position_name
                                  }}</span>
                                </div>
                              </v-col>
                              <v-col cols="12" sm="6">
                                <div class="d-flex align-center mb-2">
                                  <v-icon small color="grey" class="mr-2"
                                    >mdi-domain</v-icon
                                  >
                                  <span class="caption grey--text mr-2"
                                    >สังกัด:</span
                                  >
                                  <span class="body-2">{{
                                    personnel_temporarys.agencys
                                  }}</span>
                                </div>
                              </v-col>
                              <v-col cols="12" sm="6">
                                <div class="d-flex align-center mb-2">
                                  <v-icon small color="grey" class="mr-2"
                                    >mdi-medal</v-icon
                                  >
                                  <span class="caption grey--text mr-2"
                                    >วิทยฐานะ:</span
                                  >
                                  <span class="body-2">{{
                                    personnel_temporarys.rang_name
                                  }}</span>
                                </div>
                              </v-col>
                              <v-col cols="12" sm="6">
                                <div class="d-flex align-center mb-2">
                                  <v-icon small color="grey" class="mr-2"
                                    >mdi-school</v-icon
                                  >
                                  <span class="caption grey--text mr-2"
                                    >วุฒิ:</span
                                  >
                                  <span class="body-2">
                                    {{ personnel_temporarys.ed_abb }}:
                                    {{ personnel_temporarys.ed_name }}
                                  </span>
                                </div>
                              </v-col>

                              <v-col cols="12">
                                <div
                                  class="subtitle-2 font-weight-medium mb-3 d-flex align-center"
                                >
                                  <v-icon
                                    small
                                    color="grey darken-1"
                                    class="mr-2"
                                    >mdi-school-outline</v-icon
                                  >
                                  วุฒิการศึกษา
                                </div>

                                <v-row>
                                  <v-col cols="12" md="4">
                                    <v-select
                                      v-model="
                                        addassistantcommitteequalified.educate_levels
                                      "
                                      outlined
                                      dense
                                      :items="educate_levels"
                                      item-text="text"
                                      item-value="value"
                                      label="วุฒิการศึกษาสูงสุด"
                                      prepend-inner-icon="mdi-certificate"
                                    ></v-select>
                                  </v-col>

                                  <!-- ปริญญาตรี -->
                                  <template
                                    v-if="
                                      addassistantcommitteequalified.educate_levels ===
                                        '1' || addassistantcommitteequalified.educate_levels === 1
                                    "
                                  >
                                    <v-col cols="12" md="3">
                                      <v-text-field
                                        outlined
                                        dense
                                        v-model="
                                          addassistantcommitteequalified.assistantcommitteeQualifiedEDSub
                                        "
                                        maxlength="7"
                                        counter="7"
                                        label="วุฒิ ป.ตรี"
                                        hint="เช่น บธ.บ."
                                        persistent-hint
                                        :rules="[v => !!v || 'กรุณาระบุ']"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="5">
                                      <v-text-field
                                        outlined
                                        dense
                                        v-model="
                                          addassistantcommitteequalified.assistantcommitteeQualifiedED
                                        "
                                        label="สาขาวิชาเอก (ป.ตรี)"
                                        :rules="[v => !!v || 'กรุณาระบุ']"
                                      ></v-text-field>
                                    </v-col>
                                  </template>

                                  <!-- ปริญญาโท -->
                                  <template
                                    v-if="
                                      addassistantcommitteequalified.educate_levels ===
                                        '2'
                                    "
                                  >
                                    <v-col cols="12" md="3">
                                      <v-text-field
                                        outlined
                                        dense
                                        v-model="
                                          addassistantcommitteequalified.assistantcommitteeQualifiedEDMasterSub
                                        "
                                        maxlength="7"
                                        counter="7"
                                        label="วุฒิ ป.โท"
                                        hint="เช่น วท.ม."
                                        persistent-hint
                                        :rules="[v => !!v || 'กรุณาระบุ']"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="5">
                                      <v-text-field
                                        outlined
                                        dense
                                        v-model="
                                          addassistantcommitteequalified.assistantcommitteeQualifiedEDMaster
                                        "
                                        label="สาขาวิชาเอก (ป.โท)"
                                        :rules="[v => !!v || 'กรุณาระบุ']"
                                      ></v-text-field>
                                    </v-col>
                                  </template>

                                  <!-- ปริญญาเอก -->
                                  <template
                                    v-if="
                                      addassistantcommitteequalified.educate_levels ===
                                        '3'
                                    "
                                  >
                                    <v-col cols="12" md="3">
                                      <v-text-field
                                        outlined
                                        dense
                                        v-model="
                                          addassistantcommitteequalified.assistantcommitteeQualifiedEDDoctoralSub
                                        "
                                        maxlength="7"
                                        counter="7"
                                        label="วุฒิ ป.เอก"
                                        hint="เช่น ปร.ด."
                                        persistent-hint
                                        :rules="[v => !!v || 'กรุณาระบุ']"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="5">
                                      <v-text-field
                                        outlined
                                        dense
                                        v-model="
                                          addassistantcommitteequalified.assistantcommitteeQualifiedEDDoctoral
                                        "
                                        label="สาขาวิชาเอก (ป.เอก)"
                                        :rules="[v => !!v || 'กรุณาระบุ']"
                                      ></v-text-field>
                                    </v-col>
                                  </template>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-expand-transition>
                    </v-card-text>
                  </v-card>
                </div>
              </v-expand-transition>

              <!-- ผู้ทรงคุณวุฒิ Section -->
              <v-expand-transition>
                <div v-if="assistantcommitteeQualifiedType === 'outside'">
                  <v-card outlined class="rounded-lg">
                    <v-card-title class="primary lighten-5 py-3">
                      <v-icon color="primary" class="mr-2"
                        >mdi-account-edit</v-icon
                      >
                      <span class="font-weight-medium primary--text">
                        กรอกข้อมูลผู้ทรงคุณวุฒิ
                      </span>
                    </v-card-title>

                    <v-card-text class="pa-4">
                      <!-- ข้อมูลส่วนตัว -->
                      <div
                        class="subtitle-2 font-weight-medium mb-3 d-flex align-center"
                      >
                        <v-icon small color="grey darken-1" class="mr-2"
                          >mdi-card-account-details</v-icon
                        >
                        ข้อมูลส่วนตัว
                      </div>

                      <v-row>
                        <v-col cols="12" md="4">
                          <v-text-field
                            @input="validateInput()"
                            outlined
                            dense
                            v-model="
                              addassistantcommitteequalified.assistantcommitteeQualifiedIDcard
                            "
                            label="รหัสบัตรประชาชน"
                            maxlength="13"
                            counter="13"
                            prepend-inner-icon="mdi-card-account-details-outline"
                            :rules="[
                              v => !!v || 'กรุณาระบุ',
                              v => (!!v && v.length == 13) || 'ต้องมี 13 หลัก',
                              validateInputcheck === 'true' || 'รหัสไม่ถูกต้อง'
                            ]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="2">
                          <v-autocomplete
                            outlined
                            dense
                            v-model="
                              addassistantcommitteequalified.assistantcommitteeQualifiedTitles
                            "
                            label="คำนำหน้า"
                            :rules="[v => !!v || 'กรุณาเลือก']"
                            :items="prefixs"
                            item-text="prefix_name"
                            item-value="prefix_name"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-text-field
                            outlined
                            dense
                            v-model="
                              addassistantcommitteequalified.assistantcommitteeQualifiedFristname
                            "
                            label="ชื่อ"
                            prepend-inner-icon="mdi-account"
                            :rules="[v => !!v || 'กรุณาระบุ']"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-text-field
                            outlined
                            dense
                            v-model="
                              addassistantcommitteequalified.assistantcommitteeQualifiedLastname
                            "
                            label="นามสกุล"
                            :rules="[v => !!v || 'กรุณาระบุ']"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-divider class="my-4"></v-divider>

                      <!-- วุฒิการศึกษา -->
                      <div
                        class="subtitle-2 font-weight-medium mb-3 d-flex align-center"
                      >
                        <v-icon small color="grey darken-1" class="mr-2"
                          >mdi-school-outline</v-icon
                        >
                        วุฒิการศึกษา
                      </div>

                      <v-row>
                        <v-col cols="12" md="4">
                          <v-select
                            v-model="
                              addassistantcommitteequalified.educate_levels
                            "
                            outlined
                            dense
                            :items="educate_levels"
                            item-text="text"
                            item-value="value"
                            label="วุฒิการศึกษาสูงสุด"
                            prepend-inner-icon="mdi-certificate"
                          ></v-select>
                        </v-col>

                        <!-- ปริญญาตรี -->
                        <template
                          v-if="
                            addassistantcommitteequalified.educate_levels ===
                              '1' || addassistantcommitteequalified.educate_levels === 1
                          "
                        >
                          <v-col cols="12" md="3">
                            <v-text-field
                              outlined
                              dense
                              v-model="
                                addassistantcommitteequalified.assistantcommitteeQualifiedEDSub
                              "
                              maxlength="7"
                              counter="7"
                              label="วุฒิ ป.ตรี"
                              hint="เช่น บธ.บ."
                              persistent-hint
                              :rules="[v => !!v || 'กรุณาระบุ']"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="5">
                            <v-text-field
                              outlined
                              dense
                              v-model="
                                addassistantcommitteequalified.assistantcommitteeQualifiedED
                              "
                              label="สาขาวิชาเอก (ป.ตรี)"
                              :rules="[v => !!v || 'กรุณาระบุ']"
                            ></v-text-field>
                          </v-col>
                        </template>

                        <!-- ปริญญาโท -->
                        <template
                          v-if="
                            addassistantcommitteequalified.educate_levels ===
                              '2'
                          "
                        >
                          <v-col cols="12" md="3">
                            <v-text-field
                              outlined
                              dense
                              v-model="
                                addassistantcommitteequalified.assistantcommitteeQualifiedEDMasterSub
                              "
                              maxlength="7"
                              counter="7"
                              label="วุฒิ ป.โท"
                              hint="เช่น วท.ม."
                              persistent-hint
                              :rules="[v => !!v || 'กรุณาระบุ']"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="5">
                            <v-text-field
                              outlined
                              dense
                              v-model="
                                addassistantcommitteequalified.assistantcommitteeQualifiedEDMaster
                              "
                              label="สาขาวิชาเอก (ป.โท)"
                              :rules="[v => !!v || 'กรุณาระบุ']"
                            ></v-text-field>
                          </v-col>
                        </template>

                        <!-- ปริญญาเอก -->
                        <template
                          v-if="
                            addassistantcommitteequalified.educate_levels ===
                              '3'
                          "
                        >
                          <v-col cols="12" md="3">
                            <v-text-field
                              outlined
                              dense
                              v-model="
                                addassistantcommitteequalified.assistantcommitteeQualifiedEDDoctoralSub
                              "
                              maxlength="7"
                              counter="7"
                              label="วุฒิ ป.เอก"
                              hint="เช่น ปร.ด."
                              persistent-hint
                              :rules="[v => !!v || 'กรุณาระบุ']"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="5">
                            <v-text-field
                              outlined
                              dense
                              v-model="
                                addassistantcommitteequalified.assistantcommitteeQualifiedEDDoctoral
                              "
                              label="สาขาวิชาเอก (ป.เอก)"
                              :rules="[v => !!v || 'กรุณาระบุ']"
                            ></v-text-field>
                          </v-col>
                        </template>
                      </v-row>

                      <v-divider class="my-4"></v-divider>

                      <!-- ประสบการณ์การทำงาน -->
                      <div
                        class="subtitle-2 font-weight-medium mb-3 d-flex align-center"
                      >
                        <v-icon small color="grey darken-1" class="mr-2"
                          >mdi-briefcase-outline</v-icon
                        >
                        ประสบการณ์การทำงาน
                      </div>

                      <v-row>
                        <v-col cols="12">
                          <v-select
                            outlined
                            dense
                            v-model="
                              addassistantcommitteequalified.assistantcommitteeQualifiedPosition
                            "
                            :items="position_name_select"
                            item-text="text"
                            item-value="value"
                            label="ตำแหน่งสุดท้ายที่เคยปฏิบัติงาน"
                            prepend-inner-icon="mdi-badge-account"
                            :rules="[v => !!v || 'กรุณาระบุ']"
                          ></v-select>
                        </v-col>

                        <v-col cols="12">
                          <v-card
                            flat
                            color="grey lighten-4"
                            class="pa-3 rounded-lg"
                          >
                            <div class="caption grey--text text--darken-1 mb-2">
                              เคยสังกัด
                            </div>
                            <v-radio-group
                              v-model="
                                addassistantcommitteequalified.assistantcommitteeQualifiedTypeIO
                              "
                              row
                              class="mt-0 mb-3"
                              @change="
                                assistantcommitteeQualifiedTypeIOChange()
                              "
                            >
                              <v-radio value="vec">
                                <template v-slot:label>
                                  <v-chip
                                    :color="
                                      addassistantcommitteequalified.assistantcommitteeQualifiedTypeIO ===
                                      'vec'
                                        ? 'success'
                                        : 'grey lighten-2'
                                    "
                                    :text-color="
                                      addassistantcommitteequalified.assistantcommitteeQualifiedTypeIO ===
                                      'vec'
                                        ? 'white'
                                        : 'grey darken-1'
                                    "
                                    label
                                    class="px-4"
                                  >
                                    <span class="body-2"
                                      >สำนักงานคณะกรรมการการอาชีวศึกษา
                                      (สอศ.)</span
                                    >
                                  </v-chip>
                                </template>
                              </v-radio>
                              <v-radio value="etc">
                                <template v-slot:label>
                                  <v-chip
                                    :color="
                                      addassistantcommitteequalified.assistantcommitteeQualifiedTypeIO ===
                                      'etc'
                                        ? 'success'
                                        : 'grey lighten-2'
                                    "
                                    :text-color="
                                      addassistantcommitteequalified.assistantcommitteeQualifiedTypeIO ===
                                      'etc'
                                        ? 'white'
                                        : 'grey darken-1'
                                    "
                                    label
                                    class="px-4"
                                  >
                                    <span class="body-2">หน่วยงานอื่น</span>
                                  </v-chip>
                                </template>
                              </v-radio>
                            </v-radio-group>

                            <v-autocomplete
                              v-if="
                                addassistantcommitteequalified.assistantcommitteeQualifiedTypeIO ===
                                  'vec'
                              "
                              label="เลือกวิทยาลัย"
                              :items="colleges"
                              item-text="college_name"
                              item-value="college_name"
                              outlined
                              dense
                              prepend-inner-icon="mdi-office-building"
                              v-model="
                                addassistantcommitteequalified.assistantcommitteeQualifiedCollegeMain
                              "
                              background-color="white"
                            ></v-autocomplete>

                            <v-text-field
                              v-if="
                                addassistantcommitteequalified.assistantcommitteeQualifiedTypeIO ===
                                  'etc'
                              "
                              outlined
                              dense
                              v-model="
                                addassistantcommitteequalified.assistantcommitteeQualifiedCollegeMain
                              "
                              label="ระบุสถานที่ปฏิบัติงานสุดท้าย"
                              prepend-inner-icon="mdi-map-marker"
                              :rules="[v => !!v || 'กรุณาระบุ']"
                              background-color="white"
                            ></v-text-field>
                          </v-card>
                        </v-col>
                      </v-row>

                      <v-divider class="my-4"></v-divider>

                      <!-- เอกสารแนบ -->
                      <div
                        class="subtitle-2 font-weight-medium mb-3 d-flex align-center"
                      >
                        <v-icon small color="grey darken-1" class="mr-2"
                          >mdi-paperclip</v-icon
                        >
                        เอกสารแนบ
                      </div>

                      <v-file-input
                        v-model="assistantcommitteeQualifiedFile"
                        accept=".pdf"
                        name="assistantcommitteeQualifiedFile"
                        color="primary"
                        counter
                        label="แนบไฟล์เอกสารยืนยันตัวตน"
                        placeholder="เลือกไฟล์ PDF"
                        outlined
                        dense
                        prepend-icon=""
                        prepend-inner-icon="mdi-file-pdf-box"
                        :show-size="1000"
                        :rules="rules"
                      >
                        <template v-slot:selection="{ index, text }">
                          <v-chip
                            v-if="index < 2"
                            color="primary"
                            dark
                            label
                            small
                          >
                            <v-icon left small>mdi-file-pdf-box</v-icon>
                            {{ text }}
                          </v-chip>
                        </template>
                      </v-file-input>

                      <!-- หมายเหตุ -->
                      <v-alert
                        type="info"
                        text
                        dense
                        class="mt-3 mb-0"
                        icon="mdi-information"
                      >
                        <span class="caption">
                          หมายเหตุ: กรอกวุฒิการศึกษาที่สำเร็จในระดับสูงสุด
                        </span>
                      </v-alert>
                    </v-card-text>
                  </v-card>
                </div>
              </v-expand-transition>
            </v-form>
          </v-card-text>

          <!-- Action Buttons -->
          <v-divider></v-divider>

          <v-card-actions class="pa-4 grey lighten-4">
            <v-btn
              text
              color="grey darken-1"
              @click="addassistantcommitteequalifieddialog = false"
            >
              <v-icon left>mdi-close</v-icon>
              ยกเลิก
            </v-btn>

            <v-spacer></v-spacer>

            <!-- ปุ่มบันทึกสำหรับศึกษานิเทศก์ -->
            <v-btn
              v-if="assistantcommitteeQualifiedType === 'inside'"
              color="success"
              @click.stop="addassistantcommitteequalifiedSubmit()"
              :disabled="
                !addassistantcommitteequalified.assistantcommitteeQualifiedIDcard
              "
              depressed
              class="px-6"
            >
              <v-icon left>mdi-content-save</v-icon>
              บันทึกข้อมูล
            </v-btn>

            <!-- ปุ่มบันทึกสำหรับผู้ทรงคุณวุฒิ -->
            <v-btn
              v-else-if="
                assistantcommitteeQualifiedType === 'outside' &&
                  validateInputcheck === 'true'
              "
              color="success"
              @click.stop="addassistantcommitteequalifiedSubmit()"
              depressed
              class="px-6"
            >
              <v-icon left>mdi-content-save</v-icon>
              บันทึกข้อมูล
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog ค้นพบข้อมูล -->
      <v-layout>
        <v-dialog
          v-model="searchassistantcommitteequalifieddialog"
          persistent
          max-width="50%"
        >
          <v-card class="mx-auto pa-5">
            <base-material-card
              color="success"
              icon="mdi-account-check"
              title="ค้นพบข้อมูล"
              class="px-5 py-3"
            ></base-material-card>
            <v-card-text>
              <v-form
                ref="searchassistantcommitteequalifieddialogform"
                lazy-validation
              >
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <div class="mb-3">ยืนยันการนำเข้าข้อมูล:</div>
                      <v-list>
                        <v-list-item>
                          <v-list-item-icon>
                            <v-icon color="indigo">mdi-account-check</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title
                              >รหัสบัตรประชาชน</v-list-item-title
                            >
                            <v-list-item-subtitle>{{
                              personnel_temporarys.id_card
                            }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider inset></v-divider>
                        <v-list-item>
                          <v-list-item-icon>
                            <v-icon color="indigo"
                              >mdi-account-card-details</v-icon
                            >
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>ชื่อ-นามสกุล</v-list-item-title>
                            <v-list-item-subtitle>
                              {{ personnel_temporarys.title_s
                              }}{{ personnel_temporarys.frist_name }}
                              {{ personnel_temporarys.last_name }} เลขที่ตำแหน่ง
                              {{ personnel_temporarys.id_position }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider inset></v-divider>
                        <v-list-item>
                          <v-list-item-icon>
                            <v-icon color="indigo">mdi-map-marker</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title
                              >สังกัดปัจจุบัน</v-list-item-title
                            >
                            <v-list-item-subtitle>{{
                              personnel_temporarys.college_name
                            }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                rounded
                large
                outlined
                @click.stop="searchassistantcommitteequalifieddialog = false"
              >
                <v-icon left>mdi-close</v-icon>
                ยกเลิก
              </v-btn>
              <v-btn
                rounded
                large
                color="success"
                @click.stop="searchassistantcommitteequalifieddialogSubmit()"
              >
                <v-icon left>mdi-content-save-settings</v-icon>
                ยืนยันการนำเข้าข้อมูล
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- Dialog ลบข้อมูล -->
      <v-layout>
        <v-dialog
          v-model="deleteassistantcommitteequalifieddialog"
          persistent
          max-width="40%"
        >
          <v-card class="mx-auto pa-5">
            <base-material-card
              color="error"
              icon="mdi-delete"
              title="ลบข้อมูล"
              class="px-5 py-3"
            ></base-material-card>
            <v-card-text>
              <v-form
                ref="deleteassistantcommitteequalifiedform"
                lazy-validation
              >
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-alert type="warning" text>
                        <div class="mb-2">
                          ยืนยันการลบข้อมูลผู้ทรงคุณวุฒิ:
                        </div>
                        <div class="font-weight-bold">
                          {{
                            editassistantcommitteequalified.assistantcommitteeQualifiedTitles
                          }}{{
                            editassistantcommitteequalified.assistantcommitteeQualifiedFristname
                          }}
                          {{
                            editassistantcommitteequalified.assistantcommitteeQualifiedLastname
                          }}
                        </div>
                        <div class="text-caption">
                          รหัสบัตรประชาชน:
                          {{
                            editassistantcommitteequalified.assistantcommitteeQualifiedIDcard
                          }}
                        </div>
                      </v-alert>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                large
                outlined
                @click.stop="deleteassistantcommitteequalifieddialog = false"
              >
                <v-icon left>mdi-close</v-icon>
                ยกเลิก
              </v-btn>
              <v-btn
                large
                color="error"
                @click.stop="deleteassistantcommitteequalifiedubmit()"
              >
                <v-icon left>mdi-delete</v-icon>
                ยืนยันลบ
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- Dialog แก้ไขข้อมูล -->
      <!-- Dialog แก้ไขข้อมูล - Redesigned -->
      <v-dialog
        v-model="editassistantcommitteequalifieddialog"
        persistent
        max-width="850"
        overlay-opacity="0.7"
        transition="dialog-bottom-transition"
      >
        <v-card class="rounded-lg" elevation="8">
          <!-- Header Section -->
          <v-card-title class="warning darken-1 white--text py-4 px-6">
            <v-icon left dark size="28">mdi-account-edit</v-icon>
            <span class="font-weight-medium">
              แก้ไขข้อมูล ศึกษานิเทศก์หรือผู้ทรงคุณวุฒิ
            </span>
            <v-spacer></v-spacer>
            <v-btn
              icon
              dark
              @click="editassistantcommitteequalifieddialog = false"
            >
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="pa-6">
            <v-form ref="editassistantcommitteequalifiedform" lazy-validation>
              <!-- ลำดับในการขึ้นบัญชี -->
              <v-card
                v-if="
                  !proposalFileInfo.filename &&
                    (editassistantcommitteequalified.user_status === 'S' ||
                      editassistantcommitteequalified.user_status === '' ||
                      editassistantcommitteequalified.user_status === null 
                    ||
                      editassistantcommitteequalified.user_status === '38'
                    )
                "
                outlined
                class="mb-5 rounded-lg overflow-hidden"
              >
                <div class="amber lighten-5 pa-4">
                  <div class="d-flex align-center">
                    <v-icon color="amber darken-2" class="mr-2"
                      >mdi-sort-numeric-ascending</v-icon
                    >
                    <span class="font-weight-medium amber--text text--darken-3">
                      ลำดับในการขึ้นบัญชี (หลักเกณฑ์และวิธีการฯ ก.ค.ศ. ที่ ศธ
                      0206.7/ว 19 ลว. 19 สิงหาคม 2568 )
                    </span>
                  </div>
                </div>
                <v-card-text class="pa-4">
                  <v-select
                    v-model="
                      editassistantcommitteequalified.assistantcommitteeQualifiedRank
                    "
                    label="เลือกลำดับ"
                    :items="number_q"
                    item-text="text"
                    item-value="value"
                    outlined
                    dense
                    prepend-inner-icon="mdi-format-list-numbered"
                    hide-details
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title>
                          <v-chip
                            v-if="item.value !== '0'"
                            small
                            :color="
                              item.value === '1' || item.value === 1 ? 'primary' : 'secondary'
                            "
                            text-color="white"
                            class="mr-2"
                          >
                            อันดับ {{ item.text }}
                          </v-chip>
                          <span v-else class="grey--text">ไม่ระบุลำดับ</span>
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-select>
                </v-card-text>
              </v-card>

              <!-- ข้อมูลส่วนตัว -->
              <v-card outlined class="mb-5 rounded-lg">
                <v-card-title class="grey lighten-4 py-3">
                  <v-icon color="grey darken-1" class="mr-2"
                    >mdi-card-account-details</v-icon
                  >
                  <span class="font-weight-medium grey--text text--darken-2">
                    ข้อมูลส่วนตัว
                  </span>
                </v-card-title>

                <v-card-text class="pa-4">
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        outlined
                        dense
                        v-model="
                          editassistantcommitteequalified.assistantcommitteeQualifiedIDcard
                        "
                        label="รหัสบัตรประชาชน"
                        prepend-inner-icon="mdi-card-account-details-outline"
                        disabled
                        filled
                        background-color="grey lighten-4"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field
                        outlined
                        dense
                        v-model="
                          editassistantcommitteequalified.assistantcommitteeQualifiedTitles
                        "
                        label="คำนำหน้า"
                        :rules="[v => !!v || 'กรุณาระบุ']"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        outlined
                        dense
                        v-model="
                          editassistantcommitteequalified.assistantcommitteeQualifiedFristname
                        "
                        label="ชื่อ"
                        prepend-inner-icon="mdi-account"
                        :rules="[v => !!v || 'กรุณาระบุ']"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        outlined
                        dense
                        v-model="
                          editassistantcommitteequalified.assistantcommitteeQualifiedLastname
                        "
                        label="นามสกุล"
                        :rules="[v => !!v || 'กรุณาระบุ']"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- วุฒิการศึกษา -->
              <v-card outlined class="mb-5 rounded-lg">
                <v-card-title class="blue-grey lighten-5 py-3">
                  <v-icon color="blue-grey" class="mr-2"
                    >mdi-school-outline</v-icon
                  >
                  <span
                    class="font-weight-medium blue-grey--text text--darken-1"
                  >
                    วุฒิการศึกษา
                  </span>
                </v-card-title>
                <v-card-text class="pa-4">
                  <!-- วุฒิการศึกษา -->
                  <div
                    class="subtitle-2 font-weight-medium mb-3 d-flex align-center"
                  >
                    <v-icon small color="grey darken-1" class="mr-2"
                      >mdi-school-outline</v-icon
                    >
                    วุฒิการศึกษา
                  </div>

                  <v-row>
                    <v-col cols="12" md="4">
                      <v-select
                        v-model="editassistantcommitteequalified.educate_levels"
                        outlined
                        dense
                        :items="educate_levels"
                        item-text="text"
                        item-value="value"
                        label="วุฒิการศึกษาสูงสุด"
                        prepend-inner-icon="mdi-certificate"
                      ></v-select>
                    </v-col>

                    <!-- ปริญญาตรี -->
                    <template
                      v-if="
                        editassistantcommitteequalified.educate_levels === '1' || editassistantcommitteequalified.educate_levels === 1
                      "
                    >
                      <v-col cols="12" md="3">
                        <v-text-field
                          outlined
                          dense
                          v-model="
                            editassistantcommitteequalified.assistantcommitteeQualifiedEDSub
                          "
                          maxlength="7"
                          counter="7"
                          label="วุฒิ ป.ตรี"
                          hint="เช่น บธ.บ."
                          persistent-hint
                          :rules="[v => !!v || 'กรุณาระบุ']"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="5">
                        <v-text-field
                          outlined
                          dense
                          v-model="
                            editassistantcommitteequalified.assistantcommitteeQualifiedED
                          "
                          label="สาขาวิชาเอก (ป.ตรี)"
                          :rules="[v => !!v || 'กรุณาระบุ']"
                        ></v-text-field>
                      </v-col>
                    </template>

                    <!-- ปริญญาโท -->
                    <template
                      v-if="
                        editassistantcommitteequalified.educate_levels === '2'
                      "
                    >
                      <v-col cols="12" md="3">
                        <v-text-field
                          outlined
                          dense
                          v-model="
                            editassistantcommitteequalified.assistantcommitteeQualifiedEDMasterSub
                          "
                          maxlength="7"
                          counter="7"
                          label="วุฒิ ป.โท"
                          hint="เช่น วท.ม."
                          persistent-hint
                          :rules="[v => !!v || 'กรุณาระบุ']"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="5">
                        <v-text-field
                          outlined
                          dense
                          v-model="
                            editassistantcommitteequalified.assistantcommitteeQualifiedEDMaster
                          "
                          label="สาขาวิชาเอก (ป.โท)"
                          :rules="[v => !!v || 'กรุณาระบุ']"
                        ></v-text-field>
                      </v-col>
                    </template>

                    <!-- ปริญญาเอก -->
                    <template
                      v-if="
                        editassistantcommitteequalified.educate_levels === '3'
                      "
                    >
                      <v-col cols="12" md="3">
                        <v-text-field
                          outlined
                          dense
                          v-model="
                            editassistantcommitteequalified.assistantcommitteeQualifiedEDDoctoralSub
                          "
                          maxlength="7"
                          counter="7"
                          label="วุฒิ ป.เอก"
                          hint="เช่น ปร.ด."
                          persistent-hint
                          :rules="[v => !!v || 'กรุณาระบุ']"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="5">
                        <v-text-field
                          outlined
                          dense
                          v-model="
                            editassistantcommitteequalified.assistantcommitteeQualifiedEDDoctoral
                          "
                          label="สาขาวิชาเอก (ป.เอก)"
                          :rules="[v => !!v || 'กรุณาระบุ']"
                        ></v-text-field>
                      </v-col>
                    </template>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- ประสบการณ์การทำงาน (เฉพาะผู้ทรงคุณวุฒิภายนอก) -->
              <v-expand-transition>
                <v-card
                  v-if="
                    editassistantcommitteequalified.assistantcommitteeQualifiedType ===
                      'outside'
                  "
                  outlined
                  class="mb-5 rounded-lg"
                >
                  <v-card-title class="orange lighten-5 py-3">
                    <v-icon color="orange darken-1" class="mr-2"
                      >mdi-briefcase-outline</v-icon
                    >
                    <span
                      class="font-weight-medium orange--text text--darken-2"
                    >
                      ประสบการณ์การทำงาน
                    </span>
                  </v-card-title>

                  <v-card-text class="pa-4">
                    <div
                      class="subtitle-2 font-weight-medium mb-3 d-flex align-center"
                    >
                      <v-icon small color="grey darken-1" class="mr-2"
                        >mdi-briefcase-outline</v-icon
                      >
                      ประสบการณ์การทำงาน
                    </div>

                    <v-row>
                      <v-col cols="12">
                        <v-select
                          outlined
                          dense
                          v-model="
                            editassistantcommitteequalified.assistantcommitteeQualifiedPosition
                          "
                          :items="position_name_select"
                          item-text="text"
                          item-value="value"
                          label="ตำแหน่งสุดท้ายที่เคยปฏิบัติงาน"
                          prepend-inner-icon="mdi-badge-account"
                          :rules="[v => !!v || 'กรุณาระบุ']"
                        ></v-select>
                      </v-col>

                      <v-col cols="12">
                        <v-card
                          flat
                          color="grey lighten-4"
                          class="pa-3 rounded-lg"
                        >
                          <div class="caption grey--text text--darken-1 mb-2">
                            เคยสังกัด
                          </div>
                          <v-radio-group
                            v-model="
                              editassistantcommitteequalified.assistantcommitteeQualifiedTypeIO
                            "
                            row
                            class="mt-0 mb-3"
                            @change="assistantcommitteeQualifiedTypeIOChange()"
                          >
                            <v-radio value="vec">
                              <template v-slot:label>
                                <v-chip
                                  :color="
                                    editassistantcommitteequalified.assistantcommitteeQualifiedTypeIO ===
                                    'vec'
                                      ? 'success'
                                      : 'grey lighten-2'
                                  "
                                  :text-color="
                                    editassistantcommitteequalified.assistantcommitteeQualifiedTypeIO ===
                                    'vec'
                                      ? 'white'
                                      : 'grey darken-1'
                                  "
                                  label
                                  class="px-4"
                                >
                                  <span class="body-2"
                                    >สำนักงานคณะกรรมการการอาชีวศึกษา
                                    (สอศ.)</span
                                  >
                                </v-chip>
                              </template>
                            </v-radio>
                            <v-radio value="etc">
                              <template v-slot:label>
                                <v-chip
                                  :color="
                                    editassistantcommitteequalified.assistantcommitteeQualifiedTypeIO ===
                                    'etc'
                                      ? 'success'
                                      : 'grey lighten-2'
                                  "
                                  :text-color="
                                    editassistantcommitteequalified.assistantcommitteeQualifiedTypeIO ===
                                    'etc'
                                      ? 'white'
                                      : 'grey darken-1'
                                  "
                                  label
                                  class="px-4"
                                >
                                  <span class="body-2">หน่วยงานอื่น</span>
                                </v-chip>
                              </template>
                            </v-radio>
                          </v-radio-group>

                          <v-autocomplete
                            v-if="
                              editassistantcommitteequalified.assistantcommitteeQualifiedTypeIO ===
                                'vec'
                            "
                            label="เลือกวิทยาลัย"
                            :items="colleges"
                            item-text="college_name"
                            item-value="college_name"
                            outlined
                            dense
                            prepend-inner-icon="mdi-office-building"
                            v-model="
                              editassistantcommitteequalified.assistantcommitteeQualifiedCollegeMain
                            "
                            background-color="white"
                          ></v-autocomplete>

                          <v-text-field
                            v-if="
                              editassistantcommitteequalified.assistantcommitteeQualifiedTypeIO ===
                                'etc'
                            "
                            outlined
                            dense
                            v-model="
                              editassistantcommitteequalified.assistantcommitteeQualifiedCollegeMain
                            "
                            label="ระบุสถานที่ปฏิบัติงานสุดท้าย"
                            prepend-inner-icon="mdi-map-marker"
                            :rules="[v => !!v || 'กรุณาระบุ']"
                            background-color="white"
                          ></v-text-field>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-expand-transition>

              <!-- เอกสารแนบ (เฉพาะผู้ทรงคุณวุฒิภายนอก) -->
              <v-expand-transition>
                <v-card
                  v-if="
                    editassistantcommitteequalified.assistantcommitteeQualifiedType ===
                      'outside'
                  "
                  outlined
                  class="rounded-lg"
                >
                  <v-card-title class="teal lighten-5 py-3">
                    <v-icon color="teal" class="mr-2">mdi-paperclip</v-icon>
                    <span class="font-weight-medium teal--text text--darken-1">
                      เอกสารแนบ
                    </span>
                  </v-card-title>

                  <v-card-text class="pa-4">
                    <!-- แสดงเอกสารปัจจุบัน -->
                    <v-alert
                      v-if="
                        editassistantcommitteequalified.assistantcommitteeQualifiedFile &&
                          String(
                            editassistantcommitteequalified.assistantcommitteeQualifiedFile
                          ).length > 4
                      "
                      type="success"
                      text
                      dense
                      class="mb-4"
                    >
                      <div
                        class="d-flex align-center justify-space-between flex-wrap"
                      >
                        <div class="d-flex align-center">
                          <v-icon color="success" class="mr-2"
                            >mdi-file-check</v-icon
                          >
                          <span class="body-2">มีเอกสารยืนยันตัวตนแล้ว</span>
                        </div>
                        <v-btn
                          small
                          outlined
                          color="info"
                          @click="
                            viewpdfassistantcommitteeQualifiedFile(
                              editassistantcommitteequalified.assistantcommitteeQualifiedFile
                            )
                          "
                          class="mt-2 mt-sm-0"
                        >
                          <v-icon left small>mdi-eye</v-icon>
                          ดูเอกสาร
                        </v-btn>
                      </div>
                    </v-alert>

                    <v-alert v-else type="warning" text dense class="mb-4">
                      <v-icon color="warning" class="mr-2">mdi-alert</v-icon>
                      <span class="body-2">ยังไม่ได้แนบเอกสารยืนยันตัวตน</span>
                    </v-alert>

                    <!-- อัปโหลดเอกสารใหม่ -->
                    <div
                      class="subtitle-2 font-weight-medium mb-2 d-flex align-center"
                    >
                      <v-icon small color="grey darken-1" class="mr-2"
                        >mdi-upload</v-icon
                      >
                      อัปโหลดเอกสารใหม่ (ถ้าต้องการเปลี่ยน)
                    </div>

                    <v-file-input
                      v-model="assistantcommitteeQualifiedFile"
                      accept=".pdf"
                      name="assistantcommitteeQualifiedFile"
                      color="teal"
                      counter
                      label="เลือกไฟล์ PDF"
                      placeholder="คลิกเพื่อเลือกไฟล์"
                      outlined
                      dense
                      prepend-icon=""
                      prepend-inner-icon="mdi-file-pdf-box"
                      :show-size="1000"
                      :rules="rulesupdate"
                      hint="ไฟล์ PDF ขนาดไม่เกิน 5 MB"
                      persistent-hint
                    >
                      <template v-slot:selection="{ index, text }">
                        <v-chip v-if="index < 2" color="teal" dark label small>
                          <v-icon left small>mdi-file-pdf-box</v-icon>
                          {{ text }}
                        </v-chip>
                      </template>
                    </v-file-input>
                  </v-card-text>
                </v-card>
              </v-expand-transition>

              <!-- หมายเหตุ -->
              <v-alert
                type="info"
                text
                dense
                class="mt-4 mb-0"
                icon="mdi-information"
              >
                <span class="caption">
                  หมายเหตุ: กรอกวุฒิการศึกษาที่สำเร็จสูงสุด
                </span>
              </v-alert>
            </v-form>
          </v-card-text>

          <!-- Action Buttons -->
          <v-divider></v-divider>

          <v-card-actions class="pa-4 grey lighten-4">
            <v-btn
              text
              color="grey darken-1"
              @click="editassistantcommitteequalifieddialog = false"
            >
              <v-icon left>mdi-close</v-icon>
              ยกเลิก
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn
              color="warning darken-1"
              @click.stop="editassistantcommitteequalifiedSubmit()"
              depressed
              class="px-6"
            >
              <v-icon left>mdi-content-save-edit</v-icon>
              บันทึกการแก้ไข
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog แสดงแนวปฏิบัติ -->
      <v-layout row justify-center>
        <v-dialog v-model="pdfFileEx" max-width="80%">
          <v-card elevation="2">
            <v-card-title>
              <span>แนวปฏิบัติการเสนอรายชื่อผู้ทรงคุณวุฒิ</span>
              <v-spacer></v-spacer>
              <v-btn icon @click="pdfFileEx = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="pa-0">
              <embed src="/docEx/CommitteeEx.pdf" width="100%" height="700px" />
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- Dialog แสดงเอกสารยืนยันตัวตน -->
      <v-layout row justify-center>
        <v-dialog v-model="pdfCommitteeQfdialog" max-width="80%">
          <v-card elevation="2">
            <v-card-title>
              <span>เอกสารยืนยันตัวตน</span>
              <v-spacer></v-spacer>
              <v-btn icon @click="pdfCommitteeQfdialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="pa-0">
              <embed
                :src="'/HRCommitteeQf/' + pdfFiles"
                width="100%"
                height="700px"
              />
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- Dialog แสดงไฟล์ยืนยันการเสนอรายชื่อ -->
      <v-dialog v-model="proposalFileDialog" max-width="80%">
        <v-card>
          <v-card-title>
            <v-icon left>mdi-file-pdf-box</v-icon>
            ไฟล์ยืนยันการเสนอรายชื่อ
            <v-spacer></v-spacer>
            <v-btn icon @click="proposalFileDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="pa-0">
            <embed
              :src="'/HRProposalConfirm/' + proposalFileInfo.filename"
              width="100%"
              height="700px"
              type="application/pdf"
            />
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="assistantcommittee_proposal_dialog" max-width="50%">
        <v-card>
          <v-card-title class="error white--text">
            <v-icon left>mdi-alert-octagon</v-icon>
            ขอยกเลิกรายการเสนอชื่อผู้ทรงคุณวุฒิ
          </v-card-title>
          <v-card-text class="py-4">
            <v-row>
              <v-col cols="12">
                <div>
                  ท่านแน่ใจหรือไม่ว่าต้องการยกเลิกการเสนอรายชื่อผู้ทรงคุณวุฒิในครั้งนี้
                  การยกเลิกจะทำให้ **ไฟล์ยืนยันการเสนอรายชื่อถูกลบออกจากระบบ**
                  ท่านสามารถทำการเสนอรายชื่อใหม่ได้ในภายหลังหากต้องการ
                </div>
                <v-alert type="warning" dense text class="mt-3">
                  <v-icon left>mdi-file-remove</v-icon>
                  ไฟล์ที่จะถูกลบ:
                  <strong>{{ proposalFileInfo.filename }}</strong>
                </v-alert>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="proposalFileInfo.cancel_reason"
                  label="เหตุผลในการขอยกเลิก (จำเป็น)"
                  placeholder="เช่น มีการเปลี่ยนแปลงรายชื่อ"
                  :rules="[v => !!v || 'กรุณาระบุเหตุผลในการยกเลิก']"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              outlined
              @click="assistantcommittee_proposal_dialog = false"
              rounded
            >
              <v-icon left>mdi-close</v-icon>
              ยกเลิก
            </v-btn>
            <v-btn color="error" @click="cancelProposal()" rounded>
              <v-icon left>mdi-delete-forever</v-icon>
              ยืนยันการยกเลิก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <ReportViewer
      :report_govem_pdf="report_govem_pdf"
      v-if="showReportViewer"
      @close="closeReportViewer"
    />

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      top
    >
      <v-icon left>{{ snackbar.icon }}</v-icon>
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import AssisstantBar from "../../components/college/assisstantBar.vue";
import ReportViewer from "../../components/college/reportViewer_committee.vue";
export default {
  name: "AssistantCommitteeQualified",
  components: { AssisstantBar, ReportViewer },

  data() {
    return {
      ApiKey: "HRvec2021",
      loading: true,
      search: "",

      // Dialog states
      addassistantcommitteequalifieddialog: false,
      editassistantcommitteequalifieddialog: false,
      deleteassistantcommitteequalifieddialog: false,
      searchassistantcommitteequalifieddialog: false,
      pdfFileEx: false,
      pdfCommitteeQfdialog: false,
      proposalFileDialog: false,
      showReportViewer: false,

      // Snackbar
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },

      // Headers
      headers: [],
      selectedHeaders: [],
      headersMap: [
        {
          text: "ประเภท",
          align: "center",
          value: "assistantcommitteeQualifiedType"
        },
        {
          text: "คำนำหน้า",
          align: "center",
          value: "assistantcommitteeQualifiedTitles"
        },
        {
          text: "ชื่อ",
          align: "center",
          value: "assistantcommitteeQualifiedFristname"
        },
        {
          text: "นามสกุล",
          align: "center",
          value: "assistantcommitteeQualifiedLastname"
        },
        {
          text: "การศึกษา",
          align: "center",
          value: "assistantcommitteeQualifiedED"
        },
        {
          text: "ตำแหน่ง",
          align: "center",
          value: "assistantcommitteeQualifiedPosition"
        },
        {
          text: "ประเภท",
          align: "center",
          value: "user_status"
        },
        {
          text: "วันที่",
          align: "center",
          value: "assistantcommitteeQualifiedDateTime"
        },
        {
          text: "เอกสาร",
          align: "center",
          value: "assistantcommitteeQualifiedFile"
        },
        {
          text: "อันดับ",
          align: "center",
          value: "assistantcommitteeQualifiedRank"
        },
        { text: "แก้ไข", align: "center", value: "actions", sortable: false },
        { text: "ลบ", align: "center", value: "action_s", sortable: false }
      ],

      // Data
      assistantcommitteequalifieds: [],
      addassistantcommitteequalified: {},
      editassistantcommitteequalified: {},
      searchadd_temporary: {},
      user: {},
      periodTeachersAssisstant: {},
      prefixs: [],
      workgroups: [],
      personnel_temporarys: {},
      rate_work_course_stds: [],

      // File upload
      uploadFile: null,
      exportLoading: false,
      uploadLoading: false,
      isValidFile: false,
      proposalFileInfo: {
        filename: null,
        upload_date: null,
        cancel_reason: null
      },

      // Form states
      assistantcommitteeQualifiedType: "inside",
      assistantcommitteeQualifiedFile: null,
      validateInputcheck: "false",
      pdfFiles: "",

      // Rules
      uploadFileRules: [
        v => !v || v.size <= 10 * 1024 * 1024 || "ไฟล์ใหญ่เกินไป (สูงสุด 10MB)",
        v => !v || v.type === "application/pdf" || "เฉพาะไฟล์ PDF เท่านั้น"
      ],
      rules: [
        v => !v || v.size < 5242880 || "ไฟล์ไม่เกิน 5 MB",
        v => !!v || ""
      ],

      rulesupdate: [v => !v || v.size < 5242880 || "ไฟล์ไม่เกิน 5 MB"],

      number_q: [
        { text: "1", value: "1" },
        { text: "2", value: "2" },
        { text: "0", value: "0" }
      ],
      rankCount: 0,
      report_govem_pdf: {},
      assistantcommittee_proposal_dialog: false,
      personnel_temporarySuper: [],
      educate_levels: [
        { text: "ปริญญาตรี", value: "1" },
        { text: "ปริญญาโท", value: "2" },
        { text: "ปริญญาเอก", value: "3" }
      ],
      position_name_select: [
        { text: "ครูชำนาญการ", value: "ครูชำนาญการ" },
        { text: "ครูชำนาญการพิเศษ", value: "ครูชำนาญการพิเศษ" },
        { text: "ครูเชี่ยวชาญ", value: "ครูเชี่ยวชาญ" },
        { text: "ครูเชี่ยวชาญพิเศษ", value: "ครูเชี่ยวชาญพิเศษ" },
        { text: "รองผู้อำนวยการ", value: "รองผู้อำนวยการ" },
        { text: "คณาจารย์", value: "คณาจารย์" },
        { text: "ผู้ช่วยศาสตราจารย์", value: "ผู้ช่วยศาสตราจารย์" },
        { text: "รองศาสตราจารย์", value: "รองศาสตราจารย์" },
        { text: "ผู้อำนวยการ", value: "ผู้อำนวยการ" },
        { text: "ศึกษานิเทศก์", value: "ศึกษานิเทศก์" }
      ],
      colleges: []
    };
  },

  computed: {
    showHeaders() {
      return this.headers.filter(s => this.selectedHeaders.includes(s));
    }
  },

  async created() {
    this.headers = Object.values(this.headersMap);
    this.selectedHeaders = this.headers;
  },

  async mounted() {
    await this.initializeData();
    await this.supervision_Query();
  },

  watch: {
    assistantcommitteeQualifiedType() {
      if (this.assistantcommitteeQualifiedType === "inside") {
        // Reset form when switching type
      } else {
        this.addassistantcommitteequalified.assistantcommitteeQualifiedIDcard =
          "";
      }
    }
  },

  methods: {
    async assistantcommitteeQualifiedTypeIOChange() {
      if (
        this.addassistantcommitteequalified.assistantcommitteeQualifiedTypeIO ==
        "etc"
      ) {
        this.addassistantcommitteequalified.assistantcommitteeQualifiedETC = "";
      } else {
        this.addassistantcommitteequalified.assistantcommitteeQualifiedETC = this.addassistantcommitteequalified.assistantcommitteeQualifiedTypeIO;
      }
    },
    async personnel_temporarySuperQuery() {
      const result = await this.$http.post("personnel_temporary.php", {
        ApiKey: this.ApiKey,
        id_card: this.addassistantcommitteequalified
          .assistantcommitteeQualifiedIDcard
      });
      this.personnel_temporarys = result.data;
    },
    async cancelProposal_dialog() {
      this.proposalFileInfo.cancel_reason = null; // รีเซ็ตเหตุผล
      this.assistantcommittee_proposal_dialog = true;
    },
    async cancelProposal() {
      if (!this.proposalFileInfo.cancel_reason) {
        Swal.fire({
          icon: "warning",
          title: "กรุณาระบุเหตุผล",
          showConfirmButton: true
        });
        return;
      }

      this.assistantcommittee_proposal_dialog = false; // ปิด Dialog ก่อนส่งข้อมูล

      const confirmResult = await Swal.fire({
        icon: "warning",
        title: "ยืนยันการยกเลิกรายการ?",
        text: "การดำเนินการนี้จะลบไฟล์และข้อมูลการเสนอรายชื่อออกจากระบบ",
        showCancelButton: true,
        confirmButtonText: "ยืนยันการยกเลิก",
        cancelButtonText: "ไม่ยกเลิก",
        reverseButtons: true
      });

      if (!confirmResult.isConfirmed) return;

      try {
        let data = {
          ApiKey: this.ApiKey,
          id: this.proposalFileInfo.id,
          action: "cancel_proposal_file",
          college_code: this.user.college_code,
          period_year: this.periodTeachersAssisstant.period_college_year,
          proposal_file: this.proposalFileInfo.filename, // ส่งชื่อไฟล์เดิมไปลบ
          reason: this.proposalFileInfo.cancel_reason // ส่งเหตุผล
        };
        let result = await this.$http.post(
          "assistantcommitteequalified_proposal.php",
          data
        );

        if (result.data.status === true) {
          this.proposalFileInfo = {
            filename: null,
            upload_date: null,
            cancel_reason: null // รีเซ็ตข้อมูลหลังจากยกเลิก
          };

          Swal.fire({
            icon: "success",
            title: "ยกเลิกรายการสำเร็จ",
            text: "ไฟล์ยืนยันการเสนอรายชื่อถูกลบออกจากระบบแล้ว",
            showConfirmButton: false,
            timer: 2000
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "เกิดข้อผิดพลาดในการยกเลิก",
            text:
              result.data.message ||
              "ไม่สามารถยกเลิกไฟล์ได้ กรุณาลองใหม่อีกครั้ง",
            showConfirmButton: true
          });
        }
      } catch (error) {
        console.error("Error canceling proposal file:", error);
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่สามารถเชื่อมต่อระบบเพื่อยกเลิกไฟล์ได้",
          showConfirmButton: true
        });
      }
    },
    // ===== Initialize =====
    async initializeData() {
      const userSession = JSON.parse(sessionStorage.getItem("user")) || {};

      const result = await this.$http.post("college.php", {
        ApiKey: this.ApiKey,
        college_code: userSession.user_code
      });
      this.user = result.data;
      await this.periodQueryTeacherAssisstant(),
        await Promise.all([
          this.assistantcommitteequalifiedsQueryAll(),
          this.prefixQuery(),
          this.workgroupQuery(),
          this.rate_work_course_stdsQueryAll(),
          this.getProposalFileInfo(),
          this.collegeQuery()
        ]);
    },

    async collegeQuery() {
      const result = await this.$http.post("college.php", {
        ApiKey: this.ApiKey
      });
      this.colleges = result.data;
    },
    // ===== Query Methods =====
    async periodQueryTeacherAssisstant() {
      const result = await this.$http.post("period_college.php", {
        ApiKey: this.ApiKey,
        period_college_id: "60101"
      });
      this.periodTeachersAssisstant = result.data;
    },

    async assistantcommitteequalifiedsQueryAll() {
      this.loading = true;
      try {
        const result = await this.$http.post(
          "assistantcommitteequalified.php",
          {
            ApiKey: this.ApiKey,
            assistantcommitteeQualifiedCollege: this.user.college_code
          }
        );
        this.assistantcommitteequalifieds = result.data || [];
        let rankCount = this.assistantcommitteequalifieds.filter(
          item =>
            item.assistantcommitteeQualifiedRank === "1" ||
            item.assistantcommitteeQualifiedRank === "2"
        ).length;
        this.rankCount = rankCount;
      } catch (error) {
        console.error("Error fetching assistant committee qualifieds:", error);
      } finally {
        this.loading = false;
      }
    },

    async prefixQuery() {
      const result = await this.$http.post("prefix.php", {
        ApiKey: this.ApiKey
      });
      this.prefixs = result.data;
    },

    async workgroupQuery() {
      const result = await this.$http.post("workgroup.php", {
        ApiKey: this.ApiKey
      });
      this.workgroups = result.data;
    },

    async rate_work_course_stdsQueryAll() {
      const result = await this.$http.post("rate_work_course_std.php", {
        ApiKey: this.ApiKey
      });
      this.rate_work_course_stds = result.data;
    },

    // ===== Proposal File Methods =====
    async getProposalFileInfo() {
      try {
        let result = await this.$http.post(
          "assistantcommitteequalified_proposal.php",
          {
            ApiKey: this.ApiKey,
            action: "get_proposal_file",
            college_code: this.user.college_code,
            period_year: this.periodTeachersAssisstant.period_college_year
          }
        );

        this.proposalFileInfo = result.data;
      } catch (error) {
  
      }
    },

    onFileSelected(file) {
      if (file) {
        this.isValidFile =
          file.size <= 10 * 1024 * 1024 && file.type === "application/pdf";
      } else {
        this.isValidFile = false;
      }
    },

    async exportPDFProposal() {
      if (this.rankCount < 2) {
        Swal.fire({
          icon: "warning",
          title: "ไม่มีข้อมูล",
          text: "กรุณาเพิ่มรายชื่อผู้ทรงคุณวุฒิก่อนส่งออกไฟล์",
          showConfirmButton: true
        });
        return;
      }

      this.exportLoading = true;
      try {
        const result = await this.$http.post(
          "assistantcommitteequalified_pdf.php",
          {
            ApiKey: this.ApiKey,
            assistantcommitteeQualifiedCollege: this.user.college_code
          }
        );

        this.report_govem_pdf = result.data;
        this.showReportViewer = true;
      } catch (error) {
        console.error("Error exporting PDF proposal:", error);
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่สามารถส่งออกไฟล์ได้ กรุณาลองใหม่อีกครั้ง",
          showConfirmButton: true
        });
      } finally {
        this.exportLoading = false;
      }
    },

    closeReportViewer() {
      this.showReportViewer = false;
      this.report_govem_pdf = {};
    },

    async uploadProposalFile() {
      if (!this.uploadFile) {
        Swal.fire({
          icon: "warning",
          title: "กรุณาเลือกไฟล์",
          showConfirmButton: false,
          timer: 1500
        });
        return;
      }

      const confirmResult = await Swal.fire({
        icon: "question",
        title: "ยืนยันการอัปโหลด",
        text: this.proposalFileInfo.filename
          ? "ไฟล์เดิมจะถูกแทนที่ด้วยไฟล์ใหม่"
          : "อัปโหลดไฟล์ยืนยันการเสนอรายชื่อ",
        showCancelButton: true,
        confirmButtonText: "อัปโหลด",
        cancelButtonText: "ยกเลิก"
      });

      if (!confirmResult.isConfirmed) return;

      this.uploadLoading = true;
      try {
        const formData = new FormData();
        const timestamp = Date.now();
        const filename = `proposal_confirm_${this.user.college_code}_${timestamp}.pdf`;

        formData.append("ApiKey", this.ApiKey);
        formData.append("file", this.uploadFile);
        formData.append("filename", `../HRProposalConfirm/${filename}`);

        const uploadResult = await this.$http.post("uploadfile.php", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });

        const saveResult = await this.$http.post(
          "assistantcommitteequalified_proposal.php",
          {
            ApiKey: this.ApiKey,
            action: "save_proposal_file",
            college_code: this.user.college_code,
            period_year: this.periodTeachersAssisstant.period_college_year,
            proposal_file: filename
          }
        );
        if (saveResult.data.status === true) {
          this.proposalFileInfo = {
            filename: filename,
            upload_date: new Date().toLocaleDateString("th-TH")
          };

          Swal.fire({
            icon: "success",
            title: "อัปโหลดสำเร็จ",
            showConfirmButton: false,
            timer: 1500
          });

          this.uploadFile = null;
          this.isValidFile = false;
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่สามารถอัปโหลดไฟล์ได้ กรุณาลองใหม่อีกครั้ง",
          showConfirmButton: true
        });
      } finally {
        this.uploadLoading = false;
      }
    },

    viewProposalFile() {
      if (this.proposalFileInfo.filename) {
        this.proposalFileDialog = true;
      }
    },

    // ===== View PDF Methods =====
    viewpdfassistantcommitteeQualifiedFile(filename) {
      this.pdfFiles = filename;
      this.pdfCommitteeQfdialog = true;
    },

    viewPDFEx() {
      this.pdfFileEx = true;
    },

    // ===== Validation Methods =====
    async validateInput() {
      const value = this.addassistantcommitteequalified
        .assistantcommitteeQualifiedIDcard;

      if (!value || value.length !== 13 || !/^\d+$/.test(value)) {
        this.validateInputcheck = "false";
        return;
      }

      // Thai ID Card validation
      let sum = 0;
      for (let i = 0; i < 12; i++) {
        sum += parseInt(value.charAt(i)) * (13 - i);
      }
      const check = (11 - (sum % 11)) % 10;

      if (check === parseInt(value.charAt(12))) {
        this.validateInputcheck = "true";
      } else {
        this.validateInputcheck = "false";
      } 
    },

    async supervision_Query() {
      const result = await this.$http.post("personnel_temporary.php", {
        ApiKey: this.ApiKey,
        user_status: "S"
      });

      this.personnel_temporarySuper = result.data || {};
    },

    // ===== CRUD Methods =====
    assistantcommitteequalifiedAdd() {
      this.personnel_temporarys = {};
      this.addassistantcommitteequalified = {};
      this.assistantcommitteeQualifiedType = "inside";
      this.assistantcommitteeQualifiedFile = null;
      this.validateInputcheck = "false";
      this.addassistantcommitteequalifieddialog = true;
    },

    async addassistantcommitteequalifiedSubmit() {
      if (!this.$refs.addassistantcommitteequalifiedform.validate()) return;

      this.addassistantcommitteequalified.ApiKey = this.ApiKey;
      this.addassistantcommitteequalified.assistantcommitteeQualifiedCollege = this.user.college_code;
      this.addassistantcommitteequalified.assistantcommitteeQualifiedType = this.assistantcommitteeQualifiedType;

      if (this.assistantcommitteeQualifiedType === "inside") {
        this.addassistantcommitteequalified.assistantcommitteeQualifiedIDcard = this.personnel_temporarys.id_card;
        this.addassistantcommitteequalified.assistantcommitteeQualifiedTypeIO =
          "-";
        this.addassistantcommitteequalified.assistantcommitteeQualifiedTitles = this.personnel_temporarys.title_s;
        this.addassistantcommitteequalified.assistantcommitteeQualifiedFristname = this.personnel_temporarys.frist_name;
        this.addassistantcommitteequalified.assistantcommitteeQualifiedLastname = this.personnel_temporarys.last_name;

        this.addassistantcommitteequalified.assistantcommitteeQualifiedPosition =
          this.personnel_temporarys.position_name +
          " คศ." +
          this.personnel_temporarys.rang_level;
        this.addassistantcommitteequalified.assistantcommitteeQualifiedETC = this.personnel_temporarys.rang_name;
        this.addassistantcommitteequalified.assistantcommitteeQualifiedCollegeMain = this.personnel_temporarys.agencys;
      }

      // Upload file if exists
      if (this.assistantcommitteeQualifiedFile) {
        const formData = new FormData();
        const filename =
          this.addassistantcommitteequalified
            .assistantcommitteeQualifiedIDcard +
          this.user.college_code +
          "qf.pdf";
        formData.append("ApiKey", this.ApiKey);
        formData.append("file", this.assistantcommitteeQualifiedFile);
        formData.append("filename", "../HRCommitteeQf/" + filename);

        await this.$http.post("uploadfile.php", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });

        this.addassistantcommitteequalified.assistantcommitteeQualifiedFile = filename;
      }

      this.addassistantcommitteequalified.assistantcommitteeQualifiedDateTime = new Date();

      const result = await this.$http.post(
        "assistantcommitteequalified.insert.php",
        this.addassistantcommitteequalified
      );

      if (result.data.status === true) {
        Swal.fire({
          icon: "success",
          title: "บันทึกข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
        await this.assistantcommitteequalifiedsQueryAll();
        this.personnel_temporarys = {};
      } else {
        Swal.fire({
          icon: "warning",
          title: "ดำเนินการผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }
      this.addassistantcommitteequalifieddialog = false;
    },

    async searchassistantcommitteequalifieddialogSubmit() {
      if (!this.$refs.searchassistantcommitteequalifieddialogform.validate())
        return;

      const userSession = JSON.parse(sessionStorage.getItem("user")) || {};
      this.searchadd_temporary.ApiKey = this.ApiKey;
      this.searchadd_temporary.assistantcommitteeQualifiedCollege =
        userSession.college_code;
      this.searchadd_temporary.assistantcommitteequalified_m_type = this.personnel_temporarys.user_status;
      this.searchadd_temporary.assistantcommitteeQualifiedIDcard = this.personnel_temporarys.id_card;
      this.searchadd_temporary.assistantcommitteeQualifiedTitles = this.personnel_temporarys.title_s;
      this.searchadd_temporary.assistantcommitteeQualifiedFristname = this.personnel_temporarys.frist_name;
      this.searchadd_temporary.assistantcommitteeQualifiedLastname = this.personnel_temporarys.last_name;
      this.searchadd_temporary.assistantcommitteeQualifiedPosition = this.personnel_temporarys.position_name;
      this.searchadd_temporary.assistantcommitteeQualifiedIDcard_position = this.personnel_temporarys.id_position;
      this.searchadd_temporary.assistantcommitteequalified_level = this.personnel_temporarys.rang_level;
      this.searchadd_temporary.assistantcommitteequalified_rang = this.personnel_temporarys.rang_name;
      this.searchadd_temporary.assistantcommitteequalified_salary = this.personnel_temporarys.salary_s;
      this.searchadd_temporary.assistantcommitteequalified_branch = this.personnel_temporarys.personnel_tem_branch;

      const result = await this.$http.post(
        "assistantcommitteequalified.insert.php",
        this.searchadd_temporary
      );

      if (result.data.status === true) {
        Swal.fire({
          icon: "success",
          title: "บันทึกข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
        await this.assistantcommitteequalifiedsQueryAll();
      } else {
        Swal.fire({
          icon: "warning",
          title: "ดำเนินการผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }
      this.addassistantcommitteequalifieddialog = false;
      this.searchassistantcommitteequalifieddialog = false;
    },

    async assistantcommitteequalifiedEdit(assistantcommitteeQualifiedCollege,assistantcommitteeQualifiedIDcard) {
      const result = await this.$http.post("assistantcommitteequalified.php", {
        ApiKey: this.ApiKey,
        assistantcommitteeQualifiedIDcard: assistantcommitteeQualifiedIDcard,
        assistantcommitteeQualifiedCollege:assistantcommitteeQualifiedCollege
      });
      this.editassistantcommitteequalified = result.data;
      this.assistantcommitteeQualifiedFile = null;
      this.editassistantcommitteequalifieddialog = true;
    },

    async editassistantcommitteequalifiedSubmit() {
      if (!this.$refs.editassistantcommitteequalifiedform.validate()) return;

      // ตรวจสอบลำดับขึ้นบัญชีไม่ให้ซ้ำกัน (เฉพาะลำดับ 1 และ 2)
      const newRank = this.editassistantcommitteequalified
        .assistantcommitteeQualifiedRank;
      const currentIDcard = this.editassistantcommitteequalified
        .assistantcommitteeQualifiedIDcard;

      if (newRank === "1" || newRank === "2") {
        // ค้นหาว่ามีคนอื่นใช้ลำดับนี้อยู่แล้วหรือไม่
        const duplicateRank = this.assistantcommitteequalifieds.find(
          item =>
            item.assistantcommitteeQualifiedRank === newRank &&
            item.assistantcommitteeQualifiedIDcard !== currentIDcard
        );

        if (duplicateRank) {
          const confirmSwap = await Swal.fire({
            icon: "warning",
            title: "ลำดับซ้ำ",
            html: `ลำดับที่ <strong>${newRank}</strong> ถูกกำหนดให้กับ<br>
               <strong>${duplicateRank.assistantcommitteeQualifiedTitles}${duplicateRank.assistantcommitteeQualifiedFristname} ${duplicateRank.assistantcommitteeQualifiedLastname}</strong> อยู่แล้ว<br><br>
               ต้องการสลับลำดับหรือไม่?`,
            showCancelButton: true,
            confirmButtonText: "สลับลำดับ",
            cancelButtonText: "ยกเลิก",
            confirmButtonColor: "#FF9800",
            cancelButtonColor: "#9E9E9E"
          });

          if (!confirmSwap.isConfirmed) {
            return;
          }

          // สลับลำดับ: เปลี่ยนลำดับของคนเดิมเป็นลำดับเดิมของคนที่กำลังแก้ไข
          const oldRank =
            this.assistantcommitteequalifieds.find(
              item => item.assistantcommitteeQualifiedIDcard === currentIDcard
            ).assistantcommitteeQualifiedRank || "0";

          // อัปเดตลำดับของคนที่ซ้ำก่อน
          const swapResult = await this.$http.post(
            "assistantcommitteequalified.update_college.php",
            {
              ApiKey: this.ApiKey,
              assistantcommitteeQualifiedCollege:
                duplicateRank.assistantcommitteeQualifiedCollege,
              assistantcommitteeQualifiedIDcard:
                duplicateRank.assistantcommitteeQualifiedIDcard,
              assistantcommitteeQualifiedRank: oldRank,
              assistantcommitteeQualifiedDateTime: new Date()
            }
          );

          if (swapResult.data.status !== true) {
            Swal.fire({
              icon: "error",
              title: "เกิดข้อผิดพลาด",
              text: "ไม่สามารถสลับลำดับได้ กรุณาลองใหม่อีกครั้ง",
              showConfirmButton: true
            });
            return;
          }
        }
      }

      // Upload new file if exists
      if (this.assistantcommitteeQualifiedFile) {
        // Delete old file
        if (
          this.editassistantcommitteequalified.assistantcommitteeQualifiedFile
        ) {
          await this.$http.post("deletefile.php", {
            ApiKey: this.ApiKey,
            filename:
              "../HRCommitteeQf/" +
              this.editassistantcommitteequalified
                .assistantcommitteeQualifiedFile
          });
        }

        const formData = new FormData();
        const filename =
          this.editassistantcommitteequalified
            .assistantcommitteeQualifiedIDcard +
          this.user.college_code +
          "qf.pdf";
        formData.append("ApiKey", this.ApiKey);
        formData.append("file", this.assistantcommitteeQualifiedFile);
        formData.append("filename", "../HRCommitteeQf/" + filename);

        await this.$http.post("uploadfile.php", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });

        this.editassistantcommitteequalified.assistantcommitteeQualifiedFile = filename;
      }

      this.editassistantcommitteequalified.ApiKey = this.ApiKey;
      this.editassistantcommitteequalified.assistantcommitteeQualifiedDateTime = new Date();

      let result = await this.$http.post(
        "assistantcommitteequalified.update_college.php",
        this.editassistantcommitteequalified
      );
      if (result.data.status === true) {
        Swal.fire({
          icon: "success",
          title: "แก้ไขข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
        await this.assistantcommitteequalifiedsQueryAll();
      } else {
        Swal.fire({
          icon: "warning",
          title: "แก้ไขข้อมูลผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }
      this.editassistantcommitteequalifieddialog = false;
    },

    async assistantcommitteequalifiedDelete(
      assistantcommitteeQualifiedCollege,
      assistantcommitteeQualifiedIDcard
    ) {
      const result = await this.$http.post("assistantcommitteequalified.php", {
        ApiKey: this.ApiKey,
        assistantcommitteeQualifiedCollege: assistantcommitteeQualifiedCollege,
        assistantcommitteeQualifiedIDcard: assistantcommitteeQualifiedIDcard
      });
      this.editassistantcommitteequalified = result.data;
      this.deleteassistantcommitteequalifieddialog = true;
    },

    async deleteassistantcommitteequalifiedubmit() {
      if (!this.$refs.deleteassistantcommitteequalifiedform.validate()) return;

      this.editassistantcommitteequalified.ApiKey = this.ApiKey;

      // Delete file
      await this.$http.post("deletefile.php", {
        ApiKey: this.ApiKey,
        filename:
          "../HRCommitteeQf/" +
          this.editassistantcommitteequalified.assistantcommitteeQualifiedFile
      });

      const result = await this.$http.post(
        "assistantcommitteequalified.delete.php",
        this.editassistantcommitteequalified
      );

      if (result.data.status === true) {
        Swal.fire({
          icon: "success",
          title: "ลบข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
        await this.assistantcommitteequalifiedsQueryAll();
      } else {
        Swal.fire({
          icon: "warning",
          title: "ลบข้อมูลผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }
      this.deleteassistantcommitteequalifieddialog = false;
    }
  }
};
</script>

<style scoped>
.v-card__title {
  word-break: normal;
}

/* Radio button styling */
.v-radio >>> .v-input--selection-controls__input {
  display: none;
}

/* Smooth transitions */
.v-expand-transition-enter-active,
.v-expand-transition-leave-active {
  transition: all 0.3s ease;
}

.v-data-table >>> thead th {
  font-size: 14px !important;
  font-weight: 600 !important;
}

.fill-height {
  height: 100%;
}
</style>
